import { render, staticRenderFns } from "./PeopleName.vue?vue&type=template&id=51084c62&scoped=true&"
import script from "./PeopleName.vue?vue&type=script&lang=js&"
export * from "./PeopleName.vue?vue&type=script&lang=js&"
import style0 from "./PeopleName.vue?vue&type=style&index=0&id=51084c62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51084c62",
  null
  
)

export default component.exports